import * as React from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function InTheNeighborhood() {
  return <section data-section-id="223473" id="our-uae-headquarters" className="relative w-full min-h-[600px] md:min-h-[700px] bg-background overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/uae_tech_district_map.png)] bg-cover bg-center opacity-40 mix-blend-luminosity" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 z-0 bg-background/60 pointer-events-none" aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 md:left-2/3 -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center drop-shadow-2xl">
        <div className="w-14 h-14 bg-primary rounded-md flex items-center justify-center shadow-xl border-2 border-primary/50">
          <span className="font-mono font-bold text-2xl text-primary-foreground tracking-tighter">
            ITM
          </span>
        </div>
        <div className="w-0 h-0 border-l-[10px] border-r-[10px] border-t-[14px] border-l-transparent border-r-transparent border-t-primary mt-[-2px]" />
        <div className="w-6 h-2 bg-primary/30 rounded-md mt-1 blur-[2px]" />
      </div>

      {}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pointer-events-none flex items-center justify-start h-full py-12 md:py-0">
        <Card className="w-full max-w-md pointer-events-auto bg-card/40 backdrop-blur-xl border-border/40 shadow-3xl rounded-md">
          <CardHeader className="pb-4">
            <div className="mb-2 inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-mono font-medium bg-secondary/10 text-secondary border border-secondary/20">
              LOCAL SUPPORT
            </div>
            <CardTitle className="font-default text-4xl font-bold tracking-tighter text-foreground">
              Our UAE Headquarters
            </CardTitle>
            <CardDescription className="text-base text-muted-foreground font-default">
              Strategically located to serve the UAE's leading enterprises and luxury hospitality brands with precision.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 pb-6">
            <div className="flex items-start gap-4">
              <div className="mt-1 bg-primary/10 p-2 rounded-md shrink-0 border border-primary/20">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground mb-1">
                  Physical Address
                </h4>
                <p className="text-muted-foreground font-default leading-relaxed">
                  IT Masters Technology Hub<br />
                  Business Bay, Dubai, UAE
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="mt-1 bg-primary/10 p-2 rounded-md shrink-0 border border-primary/20">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground mb-1">
                  Direct Contact
                </h4>
                <p className="text-muted-foreground font-default leading-relaxed">
                  support@itmasters.ae<br />
                  +971 4 000 0000
                </p>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-2 border-t border-border/20">
            <Button asChild size="lg" className="w-full text-base h-12 shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground rounded-md font-default font-bold uppercase tracking-wider">
              <Link to="https://maps.google.com">
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}